const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function clean(value) {
  return String(value || '').trim();
}

function isLikelyPhone(value) {
  const text = clean(value);
  return text.length >= 6 && /\d/.test(text);
}

export function usesWeChat(communicationChannels) {
  return Array.isArray(communicationChannels) && communicationChannels.some((channel) => (
    String(channel || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '') === 'wechat'
  ));
}

/**
 * Returns the first user-facing validation error, or an empty string when the
 * agency's contact methods are valid. WeChat can replace phone/email as the
 * required contact method, while any optional values still need to be valid.
 */
export function validateAgencyContactMethods({
  communicationChannels,
  companyPhone,
  companyEmail,
  mainContact,
  secondaryContact,
}) {
  const weChatSelected = usesWeChat(communicationChannels);
  const companyPhoneValue = clean(companyPhone);
  const companyEmailValue = clean(companyEmail);
  const primary = mainContact || {};
  const secondary = secondaryContact || {};
  const mainName = clean(primary.name);
  const mainPhone = clean(primary.phone);
  const mainEmail = clean(primary.email);
  const secondaryPhone = clean(secondary.phone);
  const secondaryEmail = clean(secondary.email);

  if (!weChatSelected && (!companyPhoneValue || !companyEmailValue)) {
    return 'Company phone and email are required';
  }
  if (!mainName) {
    return 'Main contact name is required';
  }
  if (!weChatSelected && (!mainPhone || !mainEmail)) {
    return 'Main contact phone and email are required';
  }
  if (companyPhoneValue && !isLikelyPhone(companyPhoneValue)) {
    return 'Please enter a valid company phone number';
  }
  if (mainPhone && !isLikelyPhone(mainPhone)) {
    return 'Please enter a valid main contact phone number';
  }
  if (secondaryPhone && !isLikelyPhone(secondaryPhone)) {
    return 'Please enter a valid secondary contact phone number';
  }
  if (companyEmailValue && !EMAIL_RE.test(companyEmailValue)) {
    return 'Please enter a valid company email address';
  }
  if (mainEmail && !EMAIL_RE.test(mainEmail)) {
    return 'Please enter a valid main contact email';
  }
  if (secondaryEmail && !EMAIL_RE.test(secondaryEmail)) {
    return 'Please enter a valid secondary contact email';
  }
  return '';
}
